/**
 * FAT-327 — delivery-time snapshots on cart lines and orders.
 *
 * Liquid provides both the exact customer-facing messages and the cart attributes. This file
 * only keeps the selected variant and the current cart in sync with those server-rendered values.
 */
(function () {
  'use strict';

  var PROPERTY_NAME = 'properties[_delivery_time]';
  var deliveryTimes = {};

  function readMap(element) {
    try {
      return JSON.parse(element.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function collectDeliveryTimes() {
    document.querySelectorAll('[data-et-delivery-times]').forEach(function (element) {
      var map = readMap(element);
      Object.keys(map).forEach(function (variantId) {
        deliveryTimes[variantId] = map[variantId];
      });
    });
  }

  collectDeliveryTimes();

  window.ETDeliveryTimes = {
    get: function (variantId) {
      return deliveryTimes[String(variantId)] || '';
    },
    refresh: collectDeliveryTimes,
  };

  function submittedVariantId(form) {
    var radios = Array.prototype.filter.call(form.elements, function (element) {
      return element.matches && element.matches('input[data-option-position]:checked');
    });

    if (radios.length > 0) {
      var formId = form.getAttribute('id');
      var variantsElement = formId
        ? document.querySelector(
            '.et-pricing-display[data-et-form-id="' + formId + '"] script[data-et-variants]'
          )
        : null;

      if (variantsElement) {
        try {
          var match = (JSON.parse(variantsElement.textContent) || []).find(function (variant) {
            return radios.every(function (input) {
              var position = input.getAttribute('data-option-position');
              return variant['option' + position] === input.value;
            });
          });
          if (match) return String(match.id);
        } catch (error) {
          // Fall through to the form's id field.
        }
      }
    }

    var idInput = form.elements.namedItem('id');
    return idInput ? idInput.value : new FormData(form).get('id');
  }

  function messageFor(form, variantId) {
    var key = String(variantId);
    var scopedMap = form.querySelector('[data-et-delivery-times]');

    if (scopedMap) {
      var map = readMap(scopedMap);
      if (Object.prototype.hasOwnProperty.call(map, key)) return map[key];
    }

    return Object.prototype.hasOwnProperty.call(deliveryTimes, key) ? deliveryTimes[key] : null;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.elements) return;

      var inputs = Array.prototype.filter.call(form.elements, function (element) {
        return element.name === PROPERTY_NAME && element.hasAttribute('data-et-delivery-time-sync');
      });
      if (inputs.length === 0) return;

      var variantId = submittedVariantId(form);
      if (!variantId) return;

      var message = messageFor(form, variantId);
      if (message === null) return;

      inputs.forEach(function (input) {
        input.value = message;
      });
    },
    true
  );

  var lastSynced = null;
  var transientRetries = {};

  function retryTransientFailure(fingerprint) {
    if (lastSynced !== fingerprint) return;

    lastSynced = null;
    transientRetries[fingerprint] = (transientRetries[fingerprint] || 0) + 1;

    if (transientRetries[fingerprint] <= 2) {
      setTimeout(syncCartAttributes, transientRetries[fingerprint] * 1000);
    } else {
      delete transientRetries[fingerprint];
    }
  }

  function syncCartAttributes() {
    var element = document.querySelector('[data-et-delivery-attributes]');
    if (!element || element.getAttribute('data-et-delivery-attributes-dirty') !== 'true') return;

    var attributes = readMap(element);
    var fingerprint = JSON.stringify(attributes);
    if (Object.keys(attributes).length === 0 || fingerprint === lastSynced) return;

    lastSynced = fingerprint;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      keepalive: true,
      body: JSON.stringify({attributes: attributes}),
    })
      .then(function (response) {
        if (response.ok) {
          delete transientRetries[fingerprint];
        } else if (response.status === 429 || response.status >= 500) {
          retryTransientFailure(fingerprint);
        } else {
          delete transientRetries[fingerprint];
        }
      })
      .catch(function () {
        retryTransientFailure(fingerprint);
      });
  }

  function scheduleSync() {
    [200, 800, 2000].forEach(function (delay) {
      setTimeout(syncCartAttributes, delay);
    });
  }

  syncCartAttributes();

  ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleSync);
  });
})();
